/**
 * Задержка для callback, чтобы не спамить запросами
 */
export const formSerializeArray = ($form) => {
    if ($form === null) {
        return {};
    }

    const $list = $form.querySelectorAll('input[name]:not([disabled]):not([type=file]), textarea[name]:not([disabled]), select[name]:not([disabled])');
    if ($list.length === 0) {
        return {};
    }

    return [].slice.call($list).reduce((a, b, i) => {
        const val = String(b.value).replace(/\r?\n/g, "\r\n");

        if ((b.type === 'checkbox' || b.type === 'radio') && !b.checked) {
            if (typeof a[b.name] === 'undefined') a[b.name] = '';
            return a;
        }

        a[b.name] = a[b.name] && Array.isArray(a[b.name]) ? a[b.name].concat(val) : val;
        return a;
    }, {});
}

/**
 * Преобразуем args в FormData
 */
export const formData = (args) => {
    const formData = new FormData();

    for (const p in args) {
        if (args.hasOwnProperty(p)) {
            formData.append(p, args[p]);
        }
    }

    return formData;
}

/**
 * LazyLoad для iframe
 */
export const lazyFrame = ($elements) => {
    $elements = typeof $elements === 'undefined' ? document.querySelectorAll('.js-lazyFrame') : $elements;

    const lazyFrameOne = ($item) => {
        const frame = $item.dataset.frame;

        if (typeof frame === 'string' && frame.length > 0) {
            const $parent = $item.parentNode;

            $parent.innerHTML = '<iframe src="' + frame + '" frameborder="0" allowfullscreen></iframe>';
        }
    }

    if (typeof $elements.length !== 'undefined' && $elements.length >= 1) {
        $elements.forEach($item => lazyFrameOne($item));
    } else {
        lazyFrameOne($elements);
    }
}

/**
 * Аналог observer только нативный
 */
export const isScrolledIntoView = (elem) => {
    let top    = elem.offsetTop;
    let left   = elem.offsetLeft;
    const width  = elem.offsetWidth;
    const height = elem.offsetHeight;

    while(elem.offsetParent) {
        elem = elem.offsetParent;
        top += elem.offsetTop;
        left += elem.offsetLeft;
    }

    return (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        (top + height) <= (window.pageYOffset + window.innerHeight) &&
        (left + width) <= (window.pageXOffset + window.innerWidth)
    );
}